//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Characteristic from './characteristic'
import Comment from './comment'
import Illustrate from './illustrate'
import Insure from './insureFrom.vue'
export default {
    name: "de",
    data(){
        return {
            productFlag:false,
            evaluationFlag:false,
            explainFlag:false,
            infoFlag:false,
            contentList: ['product','evaluation','explain','info'],
            insureTitle:'本人信息',
            commentFlag:false,
            illustrate:"",
            insureInfo:{},
            illustInfo:[],
            comment:'',
            charac:"",
            insure:"",
            scrollHand:'',
            navFlag:0,
            commentList:[],
            templateFlag:'tk_irok',
            navHeight:'',
            productListImg:[]
        }
    },
    props: {
      navList: {
        type: Array,
      },
      productList:{
          type: Array,
          default() { return []}
      }
    },
    components:{
      Characteristic,
      Comment,
      Illustrate,
      Insure
    },
    computed: {
      claimsShow() {
          if(this.templateFlag == 'zh_mil' || this.templateFlag == 'tk_mil' || this.templateFlag == 'ta_tw'){
             return false; 
          }
        //  this.templateFlag != 'zh_mil'     //百万医疗 不显示就诊流程
      }
    },
    watch:{
        scrollHand(val){
            // console.log(this.comment,this.illustrate,this.insure,val)
            if( this.comment - val >= 1 || val == 0){
                this.navFlag = 0;
                return;
            }
            if( (this.explainFlag) && this.illustrate - val >= 1){
                this.navFlag = 1;
                return;
            }
            if( this.insure - val >= 1 ){
                this.navFlag = this.explainFlag ? 2 : 1 
            }else{
                this.navFlag = this.explainFlag ? 3 : 2 
            }
        },
        productList(val){
            if(this.productList.length > 1){
                this.productListImg =this.productList
            }
        }
    },
    created() {
          this.bus.$on("navinfo", (msg)=> {
                for(const val of this.navList){
                    if(this.contentList.includes(val.key)){
                        console.log((`${val.key}Flag`))
                        this[(`${val.key}Flag`)] = true
                    }
                }

                this.commentFlag = true
                this.commentList = msg.assessments;
                this.illustInfo = msg.settlement_list;
                this.insureInfo = msg
            });
          this.templateFlag = this.$parent.templateFlag
    },
    activated(){
        window.addEventListener('scroll', this.handleScroll)
        this.$on("hook:beforeDestroy", () => {
            window.removeEventListener('scroll', this.handleScroll);
        })
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
        this.$on("hook:beforeDestroy", () => {
            window.removeEventListener('scroll', this.handleScroll);
        })
        
    },
    methods:{
        computedSum(e,val){
            if(e - val > 0){
                return true;
            }else {
                return false;
            }
        },
        handleScroll () {
            this.scrollHand = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.navHeight = document.getElementById('viewNav') && document.getElementById('viewNav').clientHeight;
            this.productFlag && (this.charac = document.getElementById('product') && (document.getElementById('product').offsetTop-this.navHeight))
            this.evaluationFlag && (this.comment = document.getElementById('evaluation') && (document.getElementById('evaluation').offsetTop-this.navHeight))
            this.explainFlag && (this.illustrate = document.getElementById('explain') && (document.getElementById('explain').offsetTop-this.navHeight))
            this.infoFlag && (this.insure = document.getElementById('info') && (document.getElementById('info').offsetTop-this.navHeight))
        },
        navBtn(e){
            this.navFlag = e;
            let top = document.getElementById(this.navList[e].key).offsetTop - document.getElementById('viewNav').clientHeight
            this.$refs.insuref.addHeight()
            setTimeout(function(){
                scrollTo(0,top)
            },100)
            // this.$emit("navStatistics",e)
        },
        myBtn(e){
            this.$refs.insuref.navCLick(this.navFlag);
            this.navFlag = 3;
            document.getElementById('info').scrollIntoView()
        }
    }
}
